export default __webpack_public_path__ + "static/image6-cc5deb561ad4ea9160004a9992661c68.jpg";